import React from 'react'
import { FormattedDate } from 'react-intl'
import { NavLink, useLocation } from 'react-router-dom'
import { RmaOrder } from 'hooks/returns'
import { Wrapper, Heading } from './styled'

interface Props {
  data: RmaOrder
}
export const Navbar: React.FC<Props> = ({ data }) => {
  const currentPath = useLocation().pathname
  const isForm = currentPath.includes('/sales/guest/form')
  const { increment_id: incrementId, created_at: createdAt, status } = data ?? {}
  const title = isForm ? 'Orders and Returns' : `Order # ${incrementId}`

  return (
    <Wrapper>
      <Heading>
        <h1>
          {title}
          {!isForm && (
            <span className='status'>
              {status}
            </span>
          )}
        </h1>
        {isForm ? (
          <h4>Order Information</h4>
        ) : (
          <>
            <FormattedDate
              value={createdAt}
              day='numeric'
              month='long'
              year='numeric'
            />
          </>
        )}
      </Heading>
      {!isForm && (
        <ul>
          <li>
            <NavLink to='/sales/guest/view'>
              Order Information
            </NavLink>
          </li>
          <li>
            <NavLink to='/sales/guest/create-return'>
              Create Return
            </NavLink>
          </li>
        </ul>
      )}
    </Wrapper>
  )
}
